import {Divider, styled, Typography} from '@mui/material';

export const SectionHeader = ({label}: {label: string}): JSX.Element => (
  <SectionDivider>
    <Typography
      variant="caption"
      color={'secondary'}
      sx={{textTransform: 'uppercase', letterSpacing: '0.08em', marginLeft: '-10px'}}
    >
      {label}
    </Typography>
  </SectionDivider>
);

const SectionDivider = styled(Divider)(() => ({
  wrapper: {
    paddingLeft: '0px!important',
  },
  '&::before': {
    width: '0px',
    flex: '0 0 0px',
  },
}));
